module.exports = __webpack_public_path__ + "img/meet-your-evaluation-tools.2be7f47e.png";